export const APP_NAME = "Tanzania chamber of ";
export const APP_FOR_1 = "commerce";
export const APP_FOR_2 = "industry";
export const APP_FOR_3 = "agriculture";
